const DownIcon = () => {
    return ( 
        <svg width="11" height="8" viewBox="0 0 11 8" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1.51562 1.89062L5.5 6.10938L9.48438 1.89062" stroke="#4D4D4D" strokeWidth="1.875" strokeLinecap="round" strokeLinejoin="round" className="stroke"/>
        </svg>
    );
}
 
export default DownIcon;